import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { GroupCreateModalProps } from './GroupCreateModalFlighted';

export const GroupCreateModalLoader = (): Promise<typeof import('./GroupCreateModalFlighted')> =>
  import(/* webpackChunkName: "4-feat-group-create" */ './GroupCreateModalFlighted');

const LoadableGroupCreateModal: ComponentType<GroupCreateModalProps> = lazyLoadOnRender({
  loader: GroupCreateModalLoader,
});
export default LoadableGroupCreateModal;
